import React, { useEffect, useState } from "react";
import RootModel from "../../models/RootModel/RootModel";
import { useQuery } from "react-query";
import {
  fetchUserInformations,
  updateUserProfileData,
} from "../../services/userServices";
import SimpleSpinner from "../../components/Loader/SimpleSpinner";
import ProfilePicture from "../../components/ProfilePicture/ProfilePicture";
import { useForm } from "react-hook-form";
import cogoToast from "cogo-toast";
import logoImg from "../../static/images/logo.png";
import { BASE_WEB_URL } from "../../CONSTANTS";
import TextButton from "../../components/Button/TextButton/TextButton";

const UserInformatonPage = () => {
  const [loading , setLoading] = useState(false);
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      photo: null,
    },
  });

  const { isLoading, data } = useQuery(
    "user-informations",
    () => fetchUserInformations(),
    {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in data) {
        if (data[key]) {
          formData.append(key, data[key]);
        }
      }
      await updateUserProfileData(formData);
      cogoToast.success("تم تغديل المعلومات بنجاح");
      setLoading(false);
      window.location.href = "/";
    } catch (error) {
      setLoading(false);
      throw new Error(error);
    }
  };

  const [defaultImage, setDefaultImage] = useState(logoImg);

  useEffect(() => {
    if (data?.photo) {
      setDefaultImage(BASE_WEB_URL + data?.photo);
    }
  }, [data]);

  return (
    <div>
      <RootModel>
        {isLoading ? (
          <SimpleSpinner />
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="signup-comp label-up">
              <div className="user-form signup-form">
                <h2
                  style={{
                    color: "#fff",
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                >
                  المعلومات الشخصية
                </h2>
                {/* <div className="input-wrap">
                <input type="file"/>
                <label className="input-label">
                    الصورة الشخصية
                </label>
              </div> */}
                <ProfilePicture
                  register={register}
                  setValue={setValue}
                  defaultImage={defaultImage}
                />
                {errors?.photo?.type === "required" && (
                  <span>photo is required</span>
                )}

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    // value={data?.full_name}
                    defaultValue={data?.full_name}
                    {...register("full_name")}
                  />
                  <label className="input-label">الاسم</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    defaultValue={data?.father_name}
                    {...register("father_name")}
                  />
                  <label className="input-label">اسم الأب</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    defaultValue={data?.grand_father_name}
                    {...register("grand_father_name")}
                  />
                  <label className="input-label">اسم الجد</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.email}
                    disabled
                  />
                  <label className="input-label">البريد الالكتروني</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.gender === "male" ? "ذكر" : "انثى"}
                    disabled
                  />
                  <label className="input-label">الجنس</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.city}
                    disabled
                  />
                  <label className="input-label">المدينة</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.phone}
                    disabled
                  />
                  <label className="input-label">رقم الموبايل </label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.work}
                    disabled
                  />
                  <label className="input-label">العمل</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.state?.name}
                    disabled
                  />
                  <label className="input-label">الولاية</label>
                </div>

                <div className="input-wrap">
                  <input
                    type="text"
                    className="input"
                    style={{ textAlign: "right" }}
                    value={data?.locality?.name}
                    disabled
                  />
                  <label className="input-label">المحلية</label>
                </div>
              </div>
            </div>
            <TextButton
              type="submit"
              bcBlue
              rounded
              disabled={loading}
              loading={loading}
            >
              تعديل
            </TextButton>
          </form>
        )}
      </RootModel>
    </div>
  );
};

export default UserInformatonPage;
